var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlueWindowProject(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 490,
    height: 407,
    viewBox: "0 0 490 407",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M485 0H5C2.23858 0 0 2.23858 0 5V402C0 404.761 2.23858 407 5 407H485C487.761 407 490 404.761 490 402V5C490 2.23858 487.761 0 485 0Z",
    fill: "#849DC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485 1.75H5C3.20507 1.75 1.75 3.20507 1.75 5V402C1.75 403.795 3.20507 405.25 5 405.25H485C486.795 405.25 488.25 403.795 488.25 402V5C488.25 3.20507 486.795 1.75 485 1.75Z",
    stroke: "#707070",
    strokeOpacity: 0.45,
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471 56H14V390H471V56Z",
    fill: "#E9E9F2"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6_176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M471 56H14V390H471V56Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M469.75 57.25H15.25V388.75H469.75V57.25Z",
    stroke: "#575454",
    strokeOpacity: 0.29,
    strokeWidth: 2.5,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427 18L456 45",
    stroke: "#E9E9F2",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.5 47.5L458.5 20.5",
    stroke: "#E9E9F2",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459 20H429V48H459V20Z",
    stroke: "#E9E9F2",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_6_176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M372.053 175.466C373.333 178.66 374.498 181.929 375.542 185.271L372.678 186.165C373.182 187.778 373.657 189.408 374.102 191.055C374.547 192.702 374.958 194.349 375.336 195.996L378.26 195.325C379.042 198.738 379.683 202.149 380.187 205.553L377.219 205.992C377.719 209.371 378.081 212.741 378.308 216.096L381.301 215.894C381.537 219.379 381.631 222.848 381.587 226.293L378.587 226.255C378.544 229.665 378.362 233.051 378.047 236.404L381.033 236.685C380.707 240.158 380.24 243.598 379.637 246.995L376.683 246.471C376.088 249.821 375.358 253.13 374.498 256.387L377.398 257.154C376.508 260.522 375.482 263.838 374.324 267.092L371.497 266.087C370.358 269.288 369.088 272.428 367.692 275.498L370.423 276.739C368.983 279.908 367.412 283.003 365.714 286.017L363.1 284.545C361.436 287.499 359.649 290.372 357.742 293.154L360.217 294.849C358.253 297.716 356.165 300.489 353.959 303.16L351.646 301.25C349.493 303.857 347.225 306.362 344.847 308.757L346.976 310.871C344.532 313.332 341.975 315.679 339.31 317.904L337.387 315.601C334.801 317.76 332.111 319.799 329.322 321.71L331.017 324.185C328.166 326.138 325.213 327.961 322.164 329.645L320.714 327.019C317.778 328.64 314.75 330.128 311.635 331.474L312.825 334.228C309.665 335.594 306.417 336.817 303.086 337.891L302.166 335.035C300.567 335.55 298.948 336.03 297.31 336.473C295.673 336.916 294.033 337.317 292.392 337.678L293.036 340.608C289.618 341.359 286.196 341.938 282.778 342.351L282.418 339.372C279.049 339.779 275.684 340.019 272.331 340.098L272.402 343.097C268.92 343.18 265.451 343.092 262.004 342.842L262.221 339.85C258.849 339.605 255.497 339.199 252.176 338.637L251.676 341.595C248.253 341.016 244.861 340.277 241.511 339.382L242.284 336.484C239.024 335.613 235.802 334.592 232.628 333.425L231.593 336.241C228.342 335.045 225.141 333.702 222 332.215L223.284 329.504C220.235 328.061 217.244 326.48 214.318 324.767L212.802 327.356C209.817 325.608 206.9 323.725 204.059 321.715L205.793 319.266C203.041 317.318 200.361 315.245 197.764 313.054L195.83 315.347C193.189 313.119 190.632 310.772 188.166 308.311L190.285 306.188C187.901 303.807 185.603 301.317 183.401 298.723L181.114 300.664C178.881 298.033 176.745 295.298 174.713 292.462L177.151 290.715C175.189 287.977 173.327 285.144 171.571 282.22L168.999 283.765C167.225 280.811 165.558 277.767 164.006 274.637L166.693 273.304C165.199 270.292 163.813 267.199 162.543 264.028L159.758 265.144C158.478 261.95 157.313 258.68 156.269 255.339L159.133 254.444C158.629 252.832 158.154 251.202 157.709 249.555C157.264 247.908 156.853 246.261 156.475 244.614L153.551 245.284C152.769 241.872 152.128 238.46 151.624 235.057L154.592 234.618C154.092 231.239 153.73 227.868 153.503 224.514L150.51 224.716C150.274 221.231 150.18 217.762 150.224 214.316L153.224 214.355C153.267 210.944 153.449 207.559 153.764 204.205L150.778 203.924C151.104 200.451 151.571 197.012 152.174 193.615L155.128 194.139C155.723 190.788 156.453 187.48 157.313 184.222L154.413 183.456C155.302 180.088 156.329 176.772 157.487 173.517L160.313 174.523C161.453 171.322 162.723 168.182 164.118 165.112L161.387 163.87C162.828 160.702 164.399 157.606 166.097 154.593L168.711 156.065C170.375 153.111 172.162 150.238 174.068 147.456L171.594 145.76C173.558 142.894 175.646 140.12 177.851 137.45L180.165 139.36C182.318 136.753 184.586 134.248 186.964 131.853L184.835 129.739C187.279 127.278 189.836 124.93 192.501 122.705L194.424 125.009C197.009 122.85 199.7 120.811 202.489 118.9L200.794 116.425C203.645 114.472 206.598 112.649 209.647 110.965L211.097 113.591C214.033 111.97 217.061 110.482 220.176 109.136L218.985 106.382C222.146 105.016 225.394 103.792 228.725 102.719L229.645 105.574C231.244 105.059 232.862 104.58 234.5 104.137C236.138 103.694 237.778 103.293 239.419 102.932L238.775 100.002C242.193 99.2508 245.615 98.6715 249.033 98.2589L249.393 101.237C252.762 100.831 256.127 100.59 259.479 100.511L259.409 97.5122C262.891 97.4302 266.36 97.5172 269.807 97.7677L269.59 100.76C272.962 101.005 276.313 101.411 279.635 101.973L280.135 99.0145C283.558 99.5934 286.95 100.333 290.3 101.227L289.526 104.126C292.787 104.996 296.009 106.018 299.183 107.185L300.218 104.369C303.469 105.564 306.67 106.908 309.811 108.394L308.527 111.106C311.576 112.549 314.567 114.129 317.493 115.843L319.009 113.254C321.994 115.002 324.911 116.884 327.752 118.895L326.018 121.344C328.77 123.292 331.449 125.364 334.047 127.556L335.981 125.263C338.622 127.49 341.179 129.838 343.645 132.299L341.526 134.422C343.91 136.802 346.208 139.292 348.41 141.887L350.697 139.946C352.929 142.577 355.066 145.312 357.098 148.147L354.66 149.895C356.622 152.633 358.484 155.466 360.24 158.39L362.812 156.845C364.586 159.799 366.253 162.843 367.805 165.972L365.118 167.305C366.612 170.318 367.998 173.411 369.268 176.582L372.053 175.466Z",
    stroke: "#7A4074",
    strokeWidth: 6,
    strokeDasharray: "10 10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.551 177.586L364.275 176.111L363.616 176.235L363.268 176.808L364.551 177.586ZM364.551 177.586C364.275 176.111 364.275 176.111 364.275 176.111L364.276 176.111L364.281 176.11L364.301 176.106L364.381 176.091C364.452 176.078 364.557 176.058 364.696 176.031C364.972 175.979 365.379 175.901 365.9 175.799C366.943 175.597 368.442 175.301 370.265 174.931C373.911 174.189 378.85 173.147 384.023 171.943C389.201 170.738 394.595 169.377 399.159 167.998C403.794 166.597 407.362 165.237 409.05 164.088C409.508 163.776 410.032 162.976 410.361 161.32C410.678 159.718 410.758 157.593 410.601 155.045C410.287 149.962 409.049 143.48 407.203 136.766C405.359 130.06 402.925 123.184 400.25 117.32C397.555 111.411 394.685 106.69 392.026 104.149C390.93 103.103 388.905 102.288 385.88 101.852C382.904 101.423 379.183 101.391 374.941 101.709C366.463 102.345 356.111 104.364 345.905 107.188C335.7 110.012 325.708 113.622 317.946 117.41C314.063 119.306 310.777 121.227 308.312 123.092C305.805 124.989 304.321 126.699 303.776 128.119C302.524 131.378 302.478 136.655 303.363 143.013C304.237 149.299 305.981 156.388 308.077 163.106C310.173 169.822 312.606 176.12 314.841 180.821C315.96 183.176 317.013 185.093 317.93 186.451C318.389 187.132 318.792 187.639 319.128 187.982C319.442 188.302 319.612 188.392 319.64 188.406C319.645 188.409 319.645 188.409 319.643 188.408C320.609 188.701 322.386 188.608 324.784 188.106C327.098 187.622 329.723 186.819 332.216 185.951C334.703 185.086 337.027 184.168 338.73 183.465C339.581 183.114 340.276 182.817 340.756 182.609C340.997 182.505 341.183 182.423 341.309 182.367C341.372 182.339 341.42 182.318 341.452 182.304L341.487 182.288L341.496 182.284L341.497 182.284L341.498 182.284L344.112 181.107L343.588 183.926L342.113 183.651C343.588 183.926 343.588 183.926 343.588 183.926L343.588 183.926L343.587 183.929L343.585 183.941L343.576 183.987L343.543 184.17C343.513 184.331 343.47 184.569 343.415 184.874C343.306 185.485 343.15 186.365 342.965 187.443C342.595 189.599 342.11 192.54 341.65 195.683C341.189 198.829 340.754 202.164 340.483 205.113C340.285 207.272 340.181 209.159 340.204 210.595C340.692 210.119 341.293 209.46 341.997 208.615C344.393 205.743 347.551 201.266 350.719 196.531C353.877 191.809 357.015 186.878 359.365 183.125C360.539 181.249 361.516 179.669 362.198 178.558C362.54 178.002 362.807 177.564 362.99 177.265C363.081 177.116 363.151 177.001 363.198 176.924L363.251 176.837L363.264 176.815L363.267 176.81L363.268 176.808C363.268 176.808 363.268 176.808 364.551 177.586ZM340.297 212.094C340.297 212.094 340.296 212.092 340.296 212.088C340.297 212.092 340.297 212.094 340.297 212.094Z",
    fill: "#FCECFA",
    stroke: "#7A4074",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.548 171.143C359.176 168.27 365.43 157.202 362.516 146.422C359.601 135.643 348.623 129.233 337.995 132.107C327.366 134.98 321.113 146.048 324.027 156.827C326.941 167.607 337.919 174.016 348.548 171.143ZM346.363 162.446C351.372 161.092 354.179 155.359 352.633 149.641C351.087 143.923 345.774 140.385 340.765 141.739C335.757 143.093 332.949 148.826 334.495 154.544C336.041 160.262 341.354 163.8 346.363 162.446Z",
    fill: "#7A4074"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.789,
    y: 126.69,
    width: 7.68588,
    height: 7.07662,
    transform: "rotate(-15.1278 334.789 126.69)",
    fill: "#7A4074"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.79886,
    height: 6.98133,
    transform: "matrix(0.951635 0.307231 -0.26359 0.964635 349.193 125.937)",
    fill: "#7A4074"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.02211,
    height: 6.7849,
    transform: "matrix(0.617528 0.786549 -0.762555 0.646923 360.576 132.285)",
    fill: "#7A4074"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.08492,
    height: 6.72757,
    transform: "matrix(0.184826 0.982771 -0.984279 0.176623 368.424 143.856)",
    fill: "#7A4074"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.91399,
    height: 6.88143,
    transform: "matrix(-0.420863 0.907124 -0.884708 -0.466146 368.803 158.478)",
    fill: "#7A4074"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.06915,
    height: 7.64834,
    transform: "matrix(-0.691899 0.721994 -0.690902 -0.722948 362.755 169.397)",
    fill: "#7A4074"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.96605,
    height: 7.74002,
    transform: "matrix(-0.980923 0.194399 -0.200875 -0.979617 352.37 177.412)",
    fill: "#7A4074"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.11894,
    height: 8.71999,
    transform: "matrix(-0.91708 -0.398703 0.353256 -0.935527 338.692 178.357)",
    fill: "#7A4074"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.25574,
    height: 8.57461,
    transform: "matrix(-0.735179 -0.677873 0.642664 -0.766148 327.723 172.816)",
    fill: "#7A4074"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.38046,
    height: 8.43772,
    transform: "matrix(-0.254025 -0.967197 0.967458 -0.253032 319.276 161.245)",
    fill: "#7A4074"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.29782,
    height: 8.5289,
    transform: "matrix(0.181728 -0.983349 0.975085 0.221831 317.184 147.58)",
    fill: "#7A4074"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.07557,
    height: 8.76508,
    transform: "matrix(0.678864 -0.734264 0.703113 0.711078 322.461 134.47)",
    fill: "#7A4074"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M370.419 137.485C377.382 135.603 381.548 128.608 379.724 121.861C377.9 115.115 370.777 111.172 363.814 113.054C356.852 114.937 352.686 121.931 354.509 128.678C356.333 135.424 363.456 139.367 370.419 137.485ZM368.972 131.336C372.416 130.405 374.424 126.754 373.458 123.18C372.492 119.606 368.917 117.464 365.474 118.395C362.03 119.325 360.022 122.977 360.988 126.551C361.954 130.125 365.529 132.267 368.972 131.336Z",
    fill: "#7A4074"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.761,
    y: 109.677,
    width: 5.0352,
    height: 4.42887,
    transform: "rotate(-15.1278 361.761 109.677)",
    fill: "#7A4074"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.04249,
    height: 4.42251,
    transform: "matrix(0.957788 0.287476 -0.283 0.95912 371.174 109.098)",
    fill: "#7A4074"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.05719,
    height: 4.40965,
    transform: "matrix(0.630583 0.776121 -0.773662 0.633599 378.562 113)",
    fill: "#7A4074"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.06139,
    height: 4.40596,
    transform: "matrix(0.181248 0.983437 -0.983592 0.180407 383.602 120.207)",
    fill: "#7A4074"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.05003,
    height: 4.41593,
    transform: "matrix(-0.441252 0.897383 -0.895084 -0.445897 383.742 129.384)",
    fill: "#7A4074"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.22434,
    height: 4.83882,
    transform: "matrix(-0.706198 0.708014 -0.704824 -0.709382 379.711 136.284)",
    fill: "#7A4074"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.21768,
    height: 4.84494,
    transform: "matrix(-0.980326 0.197387 -0.198051 -0.980192 372.869 141.393)",
    fill: "#7A4074"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.22758,
    height: 5.54611,
    transform: "matrix(-0.925696 -0.378268 0.373606 -0.927587 363.929 142.087)",
    fill: "#7A4074"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.23657,
    height: 5.53658,
    transform: "matrix(-0.749127 -0.662426 0.658816 -0.752304 356.806 138.689)",
    fill: "#7A4074"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.24489,
    height: 5.52773,
    transform: "matrix(-0.253503 -0.967334 0.967312 -0.253587 351.374 131.486)",
    fill: "#7A4074"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.23937,
    height: 5.53361,
    transform: "matrix(0.199464 -0.979905 0.979059 0.203577 350.108 122.922)",
    fill: "#7A4074"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.22475,
    height: 5.5491,
    transform: "matrix(0.693685 -0.720279 0.717083 0.696988 353.652 114.653)",
    fill: "#7A4074"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_6_176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.012 176.702C128.564 164.344 136.27 155.812 144.224 157.646L197.224 169.862C205.178 171.696 210.368 183.2 208.817 195.558L189.825 346.82C188.273 359.178 180.568 367.71 172.613 365.877L119.614 353.66C111.659 351.826 106.469 340.322 108.021 327.964L127.012 176.702Z",
    fill: "#7A4074"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.987 184.295L202.269 200.495L184.289 343.702L114.006 327.502L131.987 184.295Z",
    fill: "#FCECFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.087 348.482C150.746 351.201 148.921 353.048 147.012 352.608C145.104 352.168 143.833 349.607 144.174 346.888C144.515 344.17 146.34 342.322 148.249 342.762C150.158 343.202 151.428 345.763 151.087 348.482Z",
    fill: "#FCECFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.322 206.132L139.87 201.768L142.405 202.352L142.292 203.248L140.333 202.796L139.898 206.264L139.322 206.132ZM152.544 204.69L147.474 203.521L147.362 204.416L152.431 205.585L152.544 204.69ZM157.613 205.858L157.501 206.753L162.57 207.922L162.683 207.027L157.613 205.858ZM167.752 208.195L167.64 209.09L172.71 210.259L172.822 209.364L167.752 208.195ZM177.891 210.532L177.779 211.427L182.849 212.596L182.961 211.701L177.891 210.532ZM188.031 212.869L187.918 213.764L189.877 214.216L189.441 217.684L190.017 217.817L190.565 213.454L188.031 212.869ZM188.922 226.544L188.346 226.411L187.25 235.138L187.826 235.27L188.922 226.544ZM186.73 243.997L186.154 243.864L185.719 247.332L183.76 246.881L183.648 247.776L186.183 248.36L186.73 243.997ZM178.578 246.608L178.691 245.712L173.621 244.544L173.509 245.439L178.578 246.608ZM168.439 244.27L168.552 243.375L163.482 242.207L163.37 243.102L168.439 244.27ZM158.3 241.933L158.412 241.038L153.343 239.87L153.231 240.765L158.3 241.933ZM148.161 239.596L148.273 238.701L143.204 237.533L143.091 238.428L148.161 239.596ZM138.022 237.259L138.134 236.364L136.176 235.913L136.611 232.444L136.035 232.312L135.487 236.675L138.022 237.259ZM137.131 223.585L137.707 223.718L138.802 214.991L138.226 214.858L137.131 223.585Z",
    fill: "#61395D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.761 298.209L128.183 294.853L130.717 295.437L130.605 296.332L128.646 295.88L128.337 298.342L127.761 298.209ZM140.856 297.774L135.787 296.605L135.675 297.501L140.744 298.669L140.856 297.774ZM145.926 298.943L145.814 299.838L150.883 301.006L150.996 300.111L145.926 298.943ZM156.065 301.28L155.953 302.175L161.022 303.343L161.135 302.448L156.065 301.28ZM166.204 303.617L166.092 304.512L171.161 305.68L171.274 304.785L166.204 303.617ZM176.343 305.954L176.231 306.849L178.19 307.3L177.881 309.762L178.457 309.895L178.878 306.538L176.343 305.954ZM177.614 316.607L177.038 316.475L176.195 323.187L176.771 323.32L177.614 316.607ZM175.928 330.033L175.352 329.9L175.043 332.362L173.084 331.91L172.972 332.805L175.507 333.389L175.928 330.033ZM167.902 331.637L168.015 330.742L162.945 329.573L162.833 330.468L167.902 331.637ZM157.763 329.299L157.876 328.404L152.806 327.236L152.694 328.131L157.763 329.299ZM147.624 326.962L147.737 326.067L142.667 324.899L142.555 325.794L147.624 326.962ZM137.485 324.625L137.598 323.73L132.528 322.562L132.416 323.457L137.485 324.625ZM127.346 322.288L127.458 321.393L125.5 320.942L125.809 318.48L125.233 318.348L124.811 321.704L127.346 322.288ZM126.075 311.635L126.652 311.768L127.494 305.055L126.918 304.922L126.075 311.635Z",
    fill: "#61395D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.797 270.604L133.254 259.184L131.68 271.714L181.224 283.134L182.797 270.604ZM132.79 258.156L130.992 272.477L181.688 284.162L183.486 269.841L132.79 258.156Z",
    fill: "#61395D"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M229.16 268.059L314.996 246.491L397.767 349.837L273.932 375.341L229.16 268.059Z",
    fill: "#FCECFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.411 281.119L320.143 263.204L329.656 285.964L256.924 303.879L247.411 281.119Z",
    fill: "#FCECFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.224 340.064L365.172 333.863L372.889 347.493L341.793 353.387L336.224 340.064Z",
    fill: "#FCECFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.739 316.646L341.967 295.041M263.468 332.745L348.696 311.139M268.805 345.513L354.033 323.907M229.16 268.059L314.996 246.491L397.767 349.837L273.932 375.341L229.16 268.059ZM247.411 281.119L320.143 263.204L329.656 285.964L256.924 303.879L247.411 281.119ZM336.224 340.064L365.172 333.863L372.889 347.493L341.793 353.387L336.224 340.064Z",
    stroke: "#7A4074",
    strokeWidth: 3
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6_176",
    x: 8,
    y: 53,
    width: 469,
    height: 346,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.459 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6_176"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6_176",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_6_176",
    x: 103.747,
    y: 97.4823,
    width: 312.432,
    height: 287.595,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6_176"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6_176",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_6_176",
    x: 103.747,
    y: 157.398,
    width: 109.344,
    height: 216.727,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6_176"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6_176",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_176"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 490,
    height: 407,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueWindowProject);
export default __webpack_public_path__ + "static/media/blue-window-project.fe5e9f8b40a9086ae015ec03bff8f231.svg";
export { ForwardRef as ReactComponent };